// import { getValueFromStorageByKey } from "@/utils/localStorage";

/**
 * Check the user has permission to access the control button, ... with permissionPolicy and permissionRole
 *
 * @param permissions = [{CapNhat: true, Permission: "QuanLyVaiTro", PermissionId: 12, Ten: "Quản lý vai trò", Xem: true}, {}]
 * @param permissionPolicy = "QuanLyVaiTro"
 * @param permissionRole CapNhat|Xem
 * @returns {*|boolean}
 */

import {
  getValueFromStorageByKey,
} from "@/utils/localStorage";

export const hasPermission = (permissions, permissionPolicy) => {
  // const permissions = getValueFromStorageByKey("permissons");
  const filteredPermission =
    permissions &&
    permissions.filter(
      permissionItem => permissionItem.name === permissionPolicy
      // permissionItem[permissionRole] === true
    );

  return filteredPermission && filteredPermission.length > 0;
};

export const hasPermissionUser = (permissionPolicy) => {
  if (permissionPolicy) {
    const permissions = getValueFromStorageByKey("permissions");
    const filteredPermission =
      permissions &&
      permissions.filter(
        (permissionItem) => permissionItem.name === permissionPolicy
      );
    return filteredPermission && filteredPermission.length > 0;
  }
  return true;
};
